// src/components/calendar/edit/Manager.js
import { enqueueSnackbar } from 'notistack';
import axiosInstance from '../../../config/axiosInstance';
import { useContext } from 'react';
import { CalendarContext } from '../../context/CalendarContext';

const buildManagerReplaceScopes = ({ ci, day, periodStart }) => {
  const scopes = [
    { kind: "employee_day", ci: String(ci), day },
    { kind: "day", day },
    { kind: "employee_period", ci: String(ci), category: "rest_between_days" },
  ];
  if (periodStart && day === periodStart) {
    scopes.push({ kind: "employee_period", ci: String(ci), category: "rotation_opening" });
  }
  return scopes;
};

export const useHandleAssignManager = () => {
  const { calendarData, setCalendarData, mergeCalendarValidationPatch } = useContext(CalendarContext);

  return async (
    ci, 
    day, 
    newManagerState, 
    station_id, 
    position_id, 
    setLoadingManager, 
    onClose
  ) => {
    setLoadingManager(true);

    if (!ci || !day || isNaN(station_id) || isNaN(position_id)) {
      enqueueSnackbar("Error: Datos insuficientes", { variant: "error" });
      setLoadingManager(false);
      return;
    }

    try {
      const response = await axiosInstance.post(
        `calendar/update_workshift_manager?ci=${ci}&day=${day}&update_manager=${newManagerState}&station_id=${station_id}&position_id=${position_id}&calendar_id=${calendarData?._id ?? ""}`,
        {}
      );

      const data = response.data;

      if (data.updated_calendar) {
        enqueueSnackbar(
          `Cobertura de encargado ${newManagerState ? "asignada" : "quitada"} correctamente`,
          { variant: "success" }
        );

        // ACTUALIZAMOS el contexto global del calendario
        setCalendarData(data.updated_calendar);
        mergeCalendarValidationPatch({
          errors: data.errors,
          warnings: data.warnings,
          replaceScopes: buildManagerReplaceScopes({
            ci,
            day,
            periodStart: calendarData?.start_date,
          }),
        });

      } else {
        enqueueSnackbar(data.message || "Error al cambiar la cobertura de encargado", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Error en la solicitud", { variant: "error" });
    }

    setLoadingManager(false);
    onClose();
  };
};
